// extracted by mini-css-extract-plugin
module.exports = {"select":"styles-module__select___3u3Yb"};